import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getFunds, getFund, createFund, updateFund } from '@lingaai/supabase-client';
import type { Fund } from '@lingaai/types';

export function useFunds(tenantId?: string) {
  return useQuery({
    queryKey: ['funds', tenantId],
    queryFn: () => getFunds(tenantId),
  });
}

export function useFund(fundId: string) {
  return useQuery({
    queryKey: ['funds', fundId],
    queryFn: () => getFund(fundId),
    enabled: !!fundId,
  });
}

export function useCreateFund() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: { tenant_id: string; name: string; external_id?: string | null; reporting_frequency?: 'monthly' | 'quarterly' | 'annual' | null }) => createFund(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['funds'] });
    },
  });
}

export function useUpdateFund() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables: { fundId: string; updates: Partial<Fund> }) => updateFund(variables.fundId, variables.updates),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['funds'] });
      queryClient.invalidateQueries({ queryKey: ['funds', variables.fundId] });
    },
  });
}
